import { combineReducers } from 'redux';
import resetpassword from './resetpassword';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import {
    REQUEST_LOGIN,
    SUCCESS_LOGIN,
    FAILURE_LOGIN,
    REQUEST_REFRESH_CLIENT_TOKEN,
    SUCCESS_REFRESH_CLIENT_TOKEN,
    FAILURE_REFRESH_CLIENT_TOKEN
} from './login/constants';
import { REQUEST_REGISTER, SUCCESS_REGISTER, FAILURE_REGISTER } from './register/constants';
import { REQUEST_LOGOUT, SUCCESS_LOGOUT, FAILURE_LOGOUT } from './logout/constants';
import {
    REFRESH_TOKEN_REQUEST,
    REFRESH_TOKEN_SUCCESS,
    REFRESH_TOKEN_FAILURE
} from './refresh/constants';
import {
    SUCCESS_PASSWORD_RESET_COMMIT,
    SUCCESS_PASSWORD_RESET_INIT
} from './resetpassword/constants';
import { NAME } from './constants';
import staging from './staging';

/*
 * State shape
 {
    token: '',
    fetching: false,
    isAuthenticated: false,
    error: ''
 }
*/

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_LOGOUT:
        case REQUEST_LOGIN:
        case REQUEST_REGISTER:
        case REFRESH_TOKEN_REQUEST:
        case REQUEST_REFRESH_CLIENT_TOKEN:
            return true;
        case SUCCESS_REGISTER:
        case SUCCESS_LOGIN:
        case SUCCESS_LOGOUT:
        case SUCCESS_REFRESH_CLIENT_TOKEN:
        case FAILURE_REGISTER:
        case FAILURE_LOGIN:
        case FAILURE_LOGOUT:
        case FAILURE_REFRESH_CLIENT_TOKEN:
            return false;
        default:
            return state;
    }
};

const token = (state = '', action) => {
    switch (action.type) {
        case SUCCESS_REGISTER:
        case SUCCESS_LOGIN:
        case REFRESH_TOKEN_SUCCESS:
        case SUCCESS_REFRESH_CLIENT_TOKEN:
            return action.response.payload.token;
        case SUCCESS_LOGOUT:
        case FAILURE_REGISTER:
        case FAILURE_LOGIN:
        case FAILURE_LOGOUT:
        case FAILURE_REFRESH_CLIENT_TOKEN:
            return '';
        default:
            return state;
    }
};

const isAuthenticated = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_REGISTER:
        case SUCCESS_LOGIN:
        case REFRESH_TOKEN_SUCCESS:
        case SUCCESS_REFRESH_CLIENT_TOKEN:
            return true;
        case SUCCESS_PASSWORD_RESET_COMMIT:
        case SUCCESS_PASSWORD_RESET_INIT:
        case SUCCESS_LOGOUT:
        case FAILURE_REGISTER:
        case FAILURE_LOGIN:
        case FAILURE_LOGOUT:
        case FAILURE_REFRESH_CLIENT_TOKEN:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_REGISTER:
        case FAILURE_LOGIN:
        case FAILURE_LOGOUT:
        case REFRESH_TOKEN_FAILURE:
        case FAILURE_REFRESH_CLIENT_TOKEN:
            return action.response.message;
        case SUCCESS_LOGIN:
        case SUCCESS_LOGOUT:
        case SUCCESS_REGISTER:
        case REQUEST_LOGIN:
        case REQUEST_LOGOUT:
        case REQUEST_REGISTER:
        case REQUEST_REFRESH_CLIENT_TOKEN:
            return '';
        default:
            return state;
    }
};

// Persist only token
const authenticationPersistConfig = {
    key: NAME,
    storage: storage,
    whitelist: ['token', 'isAuthenticated']
};

const reducer = combineReducers({
    fetching,
    isAuthenticated,
    token,
    error,
    [resetpassword.constants.NAME]: resetpassword.reducer,
    [staging.constants.NAME]: staging.reducer
});

export default persistReducer(authenticationPersistConfig, reducer);



// WEBPACK FOOTER //
// ./src/services/authentication/reducer.js